import { Stack } from '@mui/material';
import React from 'react';

const PatientInfoStack = ({
  ImageSource,
  paragraph,
  clickable,
  navigate,
  path,
  Patient,
  func,
  setForceRender,
  i18n,
}) => {
  return (
    <React.Fragment>
      {ImageSource ? (
        <Stack
          direction={
            i18n?.language === 'en' ? 'row' : 'row-reverse'
          }
          spacing={2}
          sx={{ cursor: clickable && 'pointer' }}
          onClick={() => {
            Patient &&
              window.sessionStorage.setItem(
                'patient',
                JSON.stringify(Patient)
              );
            path && navigate(path);
            func && func(Patient, setForceRender);
          }}
        >
          <img
            src={ImageSource}
            alt={paragraph ?? 'unknown'}
            width={20}
            height={20}
            loading="..."
          />
          {clickable ? (
            <h4>{paragraph}</h4>
          ) : (
            <p
              style={{
                textAlign:
                  i18n?.language === 'en' && 'left',
              }}
            >
              {paragraph}
            </p>
          )}
        </Stack>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default PatientInfoStack;
